// extracted by mini-css-extract-plugin
export default {"squares":"giGs7xLdGYgb9TeNXnve","square":"l7chVmXZQrw5eD9bIiyK","iconWrapper":"vNsoEU8GFMmB6kmy8wnN","icon":"VSNILuC6mUy9oBBUgWKh","text":"foxoymRvN1fjzab6COyD"};